<template>
    <div>
        <div>
            <el-form :model="queryForm" :inline="true"  style="text-align:left;" label-width="100px" class="queryform-class">
                <el-row>
                    <el-col :span="9">
                        <el-form-item label="延保产品名称:" class="prod-select">
                            <My-Select v-model="queryForm.prodName" :objSelect="queryForm.prodName" :options="ewProductList" :placeholder="ewPlaceholder"
                                :optionBind="optionBindEw"  @changeSelct="changeEwSelct" :clearable='true'></My-Select>                
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="承销商:" class="agent-select">
                            <My-Select v-model="queryForm.agentCode" :objSelect="queryForm.agentCode" :options="agentList" :placeholder="agentPlaceholder"
                                    :optionBind="optionBindAgent" @changeSelct="changeAgent" :clearable='true'></My-Select>                
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item label="品类:" class="agent-select">
                            <My-Select v-model="queryForm.dicTypeCode" :objSelect="queryForm.dicTypeCode" :options="categoryList" :placeholder="categoryPlaceholder"
                            :optionBind="optionBindCategory"  @changeSelct="changeCategorySelct" :clearable='true'></My-Select>                 
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="延保销售时间:" class="datatime-class">
                            <el-date-picker
                                v-model="queryForm.createTimeStart"
                                type="datetime"
                                placeholder="开始时间" value-format="yyyy-MM-dd HH:mm:ss">
                            </el-date-picker>
                            <span> - </span>   
                            <el-date-picker
                                v-model="queryForm.createTimeEnd"
                                type="datetime"
                                default-time = "23:59:59"
                                placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss">
                            </el-date-picker>        
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">                      
                        <el-button type="primary" plain @click="query()">查询</el-button>
                        <el-button type="primary" plain @click="exportExt()">导出</el-button> 
                    </el-col>                    
                </el-row>
            </el-form>
        </div>
        <div>
            <My-table :configurationData="configurationData" :operation="operation" :getTableParam="getTableParam" ref="myTable"> </My-table>
        </div>          
    </div>
</template>

<script>
import  asyncApi   from '../../api/asyncApi';
export default { 
    name: 'extendedWarrantyBills',
    data(){
        return{  
            agentPlaceholder:'请选择承销商名称',
            categoryPlaceholder:'请选择品类',
            ewPlaceholder:'请选择延保产品',  
            ewProductList:[], 
            categoryList:[],  
            agentList:[],    
            queryForm:{
                createTimeStart:'',
                createTimeEnd:'',
                prodName:'',
                agentCode:'',
                dicTypeCode:''
            },
            optionBindEw:{
                label:"prodName",
                value:"prodCode"
            },
            optionBindCategory:{
                label:"dicTypeName",
                value:"dicTypeCode"
            },
            optionBindAgent:{
                label:"agentName",
                value:"agentCode"
            },
             // 列表配置
            configurationData:[
                {
                    title: '承销商',
                    propertys: 'agentName',
                    width: ''
                },
                {
                    title: '延保产品名称',
                    propertys: 'prodName',
                    width: ''
                },
                {
                    title: '品类',
                    propertys: 'dicTypeName',
                    width: ''
                },
                {
                    title: '延保销售单量',
                    propertys: 'extensionlistNum',
                    width: ''
                },
                {
                    title: '延保销售金额(元)',
                    propertys: 'extensionMoney',
                    width: ''
                },
                {
                    title: '承销商分成金额(元)',
                    propertys: 'agentMoney',
                    width: ''
                },
                {
                    title: '友穗分成金额(元)',
                    propertys: 'ysMoney',
                    width: ''
                },
                {
                    title: '其他分成金额(元)',
                    propertys: 'otherMoney',
                    width: ''
                }
            ],
             // 是否有操作按钮 宽度
            operation: {
                show: false,
                width: ''
            },
            getTableParam:{
                url:'/extwarapi/api/statistic/getExtensionBill',
                param:''
            }
        }
    },
    methods:{    
        query(){
            this.getTableParam.param=this.queryForm;
            this.$refs["myTable"].query(1);
        },
        changeEwSelct(value){
            this.queryForm.prodName=value;
        },
        changeCategorySelct(value){
            this.queryForm.dicTypeCode=value;
        },
        changeAgent(value){
            this.queryForm.agentCode=value;             
        },
        exportExt(){
            let url="/extwarapi/api/statistic/getExtensionBillExport";
            let param=Object.assign({},this.queryForm);
                param.pageNum=1;
                param.pageSize=9999;
            this.axios.post(url, param,{responseType: "blob"}).then((resp) => {
                let fileName=decodeURIComponent(resp.headers["content-disposition"]).split('=')[1];
                let blob = new Blob([resp.data], { type: ".xlsx" });
                if (window.navigator.msSaveOrOpenBlob) {
                    navigator.msSaveBlob(blob,fileName);
                } else {
                    let a = document.createElement("a");
                    a.download = fileName;
                    a.href = window.URL.createObjectURL(blob);
                    a.click();
                    //释放内存
                     window.URL.revokeObjectURL(a.href)
                }
            }).catch((resp) => {
              //console.log('error', resp); 
            })
        },
        //获取延保产品字典
        async getEwProduct(){
            let url ="/extwarapi/api/extension/getProdName";
            let data = await asyncApi.post(url,'');  
            if(data.code=='0000'){
                this.ewProductList=data.result;
            } 
        },
        //获取承销商数据字典
        async getAgentList(){
            let url ="/extwarapi/api/agent/getAgentEnum";
            let data = await asyncApi.post(url,null);  
            if(data.code=='0000'){
                this.agentList=data.result;
            }
        },
        //获取品类产品字典
        async getCategory(){
            let url ="/extwarapi/api/dicProdType/getTypeEnum";
            let data = await asyncApi.post(url,null);  
            if(data.code=='0000'){
                this.categoryList=data.result;
            }
        },
       
    },
    mounted(){
        this.getEwProduct();
        this.getAgentList();
        this.getCategory();
    }
 
}
</script>

<style lang="scss" >
.queryform-class {     
    .datatime-class .el-date-editor {
        width: 190px
    };
    .prod-select .el-input__inner{
        width: 292px;
    }
    .agent-select  .el-input__inner{
        width: 190px;
    }
}
</style>